
































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import  { MswApiService } from '@/shared/msw-api-service';
import { confirmService, ConfirmOptions } from '@libs-uuif/shared/confirm-service';
import { CreateElement, VNode } from 'vue';
import { IBasicdetails, IVulnerabilityResponse } from '@/shared/types/shared-types';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
const cssPrefix = 'msw-supportcases-widget';

@Component({
  components: {
    MswWidgetCard,
    SwBarProgress,
    SwIcon,
    SwCheckbox,
    SwStatusInfo: SwStatusInfo as any,
  },
})
export default class MswSupportcasesWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  casesInWait = '0';
  openCases = '0';
  waitForResp = false;
  doNotShowAlertAgain: boolean = false;
  showOptInBanner: boolean = false;

  @Prop({ type: Boolean, default: false })
  showOptInSuccess: boolean;

  @Watch('showOptInSuccess')
  onShowOptInSuccess(val: boolean) {
    if (val) {
      this.showOptInBanner = true;
    }
  }

  routeToCases() {
    // Redirecting to managecases page
    this.$store.dispatch('navigateTo', 'ui/managecases');
  }

  dismissOptInBanner() {
    this.showOptInBanner = false;
  }

  created() {
    this.waitForResp = true;
    // const supportData = localStorage.getItem('supportCasesData') || null;
    // if (supportData === null) {
    MswApiService.widgetsInfo.getSupportCases()
      .then((resp:any) => {
        this.waitForResp = false;
        localStorage.setItem('supportCasesData', JSON.stringify(resp));
        if (resp['msgDesc'] === 'Success') {
          this.casesInWait  = resp['waitOnCustomerCount'] ? resp['waitOnCustomerCount'] : '0';
          this.openCases = resp['openCaseCount'] ? resp['openCaseCount'] : '0';
          if (resp['isShowOptInTransition'] === 'YES') {
            this.showOptInBanner = true;
          }
          if (resp['issueexist'] === 'YES') {
            const options: ConfirmOptions = {
              status: 'major',
              title: String(resp['issueheader']),
              message: this.getVulnerabilityMessage(resp),
              buttons: [{ key: 'ok', name: String(resp['issueoktext']), isDefault: true }],
            };

            if (resp['issuecanceltext']) {
              options.buttons?.splice(0, 0, { key: 'cancel', name: String(resp['issuecanceltext']) });
            }
            confirmService.confirm(options)
            .then((isConfirmed : any) => {
              if (isConfirmed === 'ok') {
                if (this.doNotShowAlertAgain && resp.showdonotdisplay === 'YES') {
                  const payload: IBasicdetails = {
                    mode: 'SHOWPREFDONOTDISPLAY',
                    showPrefDonotDisplayValue: this.doNotShowAlertAgain ? 'YES' : 'NO',
                  };
                  MswApiService.widgetsInfo.updateBaseDetails(payload).then(() => {
                    window.open(resp['issueactionurl'], '_blank');
                  })
                  .catch((errRes: any) => {
                    console.error(errRes);
                  });
                } else {
                  window.open(resp['issueactionurl'], '_blank');
                }
              }
            });
          }
        }
        if (resp['msgDesc'] !== 'Success') {
          throw new Error(resp['msgDesc']);
        }
      })
      .catch((err:any) => {
        this.waitForResp = false;
        console.warn(`Error:${err}`);
      });
    // } else {
    //   const tempSupportData = typeof(supportData) === 'string' ? JSON.parse(supportData) : {};
    //   this.waitForResp = false;
    //   this.casesInWait  = tempSupportData['waitOnCustomerCount'] ? tempSupportData['waitOnCustomerCount'] : '-';
    //   this.openCases = tempSupportData['openCaseCount'] ? tempSupportData['openCaseCount'] : '-';
    // }
  }

  getVulnerabilityMessage(resp: IVulnerabilityResponse): (h: CreateElement) => VNode {
    return (h: CreateElement): VNode => { // tslint:disable-line
      return (
        <div>
          <span>{ resp.issuetext }</span>
          { resp.showdonotdisplay === 'YES' && <div style={{ margin: '1rem 0rem' }}>
            <SwCheckbox
              name="doNotShowAlertAgain"
              props-checked={this.doNotShowAlertAgain}
              nativeOn-click={ () =>
                this.doNotShowAlertAgain = this.doNotShowAlertAgain ? this.doNotShowAlertAgain = false : this.doNotShowAlertAgain = true }>
              { resp.showdonotdisplaytext }
            </SwCheckbox>
          </div> }
        </div>
      ) as VNode;
    };
  }
}
